import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { person1, person2, person3, starTestimonial } from 'images/retail-energy';
import { nanoid } from 'nanoid';
import React, { FC } from 'react';

const reviews: TReview[] = [
  {
    name: 'Terence Ludwig',
    stars: 5,
    review:
      'I couldn’t believe how much I was able to save by simply switching my energy supplier! And it is thanks to Energy5 that I now know how you can benefit from deregulated energy markets. I encourage everyone to do the same – it’s just so simple, and you can do it all online.',
    icon: person1,
  },
  {
    name: 'Lidia Kent',
    stars: 5,
    review:
      'With Energy5, I was able to save a pretty penny on that electricity bill. All I had to do was switch my energy supplier. With this intuitive platform, I could save time and cut costs by taking all switch-related processes online, pretty much on the go.',
    icon: person2,
  },
  {
    name: 'Herbert Elliot',
    stars: 5,
    review:
      'To anyone looking for new ways to save on energy – seek no further! Energy5 got me some significant energy savings, and the best thing about it – I never needed to lift a finger! Now my business is much more energy-efficient than it was before.',
    icon: person3,
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(6, 0, 20),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 0, 30),
    },
  },
  card: {
    boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.15)',
    borderRadius: theme.spacing(3),
    background: theme.palette.switchedColors.simpleCard,
    padding: theme.spacing(6),
    height: '100%',
  },
  name: {
    fontWeight: 700,
    marginLeft: theme.spacing(4),
  },
  review: {
    fontSize: 16,
    color: theme.palette.switchedColors.textGray,
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginBottom: 0,
    },
  },
}));

const Testimonials: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container fixed>
        <Grid spacing={6} container>
          <Grid lg={3} xs={12} item>
            <Typography className={classes.title} variant="h2">
              What our clients say
            </Typography>
          </Grid>
          {reviews.map((props, index) => (
            <Grid key={index} item lg={3} md={4} xs={12}>
              <TestimonialCard {...props} classes={classes} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

type TReview = {
  name: string;
  icon: string;
  stars: 1 | 2 | 3 | 4 | 5;
  review: string;
};

interface TestimonialCardProps extends TReview {
  classes: ClassNameMap<string>;
}

function repeat(items: number) {
  const arr = [];
  for (let index = 0; index < items; index++) {
    arr.push(nanoid());
  }
  return arr;
}

const TestimonialCard: FC<TestimonialCardProps> = ({ classes, icon, name, stars, review }) => (
  <Box className={classes.card}>
    <Box display="flex" alignItems="center" mb={6}>
      <img width="50px" src={icon} alt="name" />
      <Typography className={classes.name}>{name}</Typography>
    </Box>
    <Box display="flex" mb={2}>
      {repeat(stars).map((id) => (
        <img key={id} src={starTestimonial} alt="star" />
      ))}
    </Box>
    <Typography className={classes.review}>{review}</Typography>
  </Box>
);

export default Testimonials;
